/**
 * uid の先頭を短縮した識別子ラベル (admin 画面で同名ニックネームの投稿者/参加者を見分けるため)。
 *
 * 一般ユーザ向けには内部識別子を出さない方針 (UI 内部key非表示ルール) だが、admin の
 * 投稿者選択 UI では「同じニックネームの別人」を一意に区別する必要があり、詳細モーダルでも
 * authorUid を表示しているのと同じ運用として表示を許容する。
 *
 * 選択 / フィルターの内部キーは常にフル uid を使い、本関数は **表示専用の補助ラベル**。
 * 匿名認証 uid は 28 文字英数字なので先頭 6 文字で実用上一意。
 *
 * 例: "abc123XYZ..." → "abc123"
 */
export function shortUid(uid: string, length = 6): string {
  return uid.slice(0, length);
}
